import React, { useState } from "react";
import { CreateMetaData } from "../../api/api";
import Cookies from "js-cookie";
import {CreateMetaDataForm} from './CreateMetadata'
import { CreateParameterForm } from "./CreateParameterForm";



const CreateTask = () => {

    const [currentForm, setCurrentForm] = useState(1);

  const handleNext = () => {
    setCurrentForm(2);
  };

  const handleCancel = () => {
    setCurrentForm(1);
  };
  console.log(currentForm)
  
  return (
    <>
    <CreateMetaDataForm />
    </>
  );
};

export { CreateTask };
